export const SET_LANG = 'SET_LANG'
export const SET_MENU_NAV = 'SET_MENU_NAV'
export const FETCH_DELIVERY_OPTION_LIST = 'FETCH_DELIVERY_OPTION_LIST'
export const DELIVERY_QUOTATION_LIST = 'DELIVERY_QUOTATION_LIST'

export const FETCH_MARKETPLACE_ORDER_LIST = 'FETCH_MARKETPLACE_ORDER_LIST'
export const SET_MARKETPLACE_ORDER_IDS = 'SET_MARKETPLACE_ORDER_IDS'
export const SET_MARKETPLACE_ORDER_DETAIL = 'SET_MARKETPLACE_ORDER_DETAIL'
export const SCAN_MARKETPLACE_ORDER_TRACKING_NO = 'SCAN_MARKETPLACE_ORDER_TRACKING_NO'
export const SET_CURRENT_PAGE_NUM = 'SET_CURRENT_PAGE_NUM'
